export const BALANCE_SHEET = "Balance Sheet"
export const SETTINGS = "Balance Sheet Settings"
export const SAVE = "Save"

export const BALANCE_SHEET_SUMMARY_FIELDS = [
    {id: 'name', label: 'Name', align: "center"},
    {id: 'amount', label: 'Amount', align: "center"},
]

export const BALANCE_SHEET_PAGES = {
    TABLE: "table",
    SETTINGS: "settings",
}

export const INCOME_SOURCE_OPTIONS = [
    "Ledgers",
    "Income Statement"
];

export const INCOME_CURRENCY_OPTIONS = [
    "CAD",
    "USD",
];

// tooltip names
export const BACK = "Back to Menu"